export const PREVIEWING_BANNER_HEIGHT = '46px';
